if (!window.croCartEditor) {
  window.croCartEditor = true;
  let selected = false;
  let selectedBlock = null;
  const dismiss = () => {
    selected = false;
    selectedBlock = null;
    document.getElementById('Cart-Drawer')?.classList.remove('active');
    document.body.classList.remove('open-cc');
  };
  const update = () => {
    const drawer = document.getElementById('Cart-Drawer');
    if (window.theme?.settings && drawer) theme.settings.cart_drawer = drawer.dataset.cartMode !== 'page';
    if (selected && window.Shopify?.designMode && drawer) {
      drawer.open?.();
      document.body.classList.remove('open-cc');
    }
  };
  document.addEventListener('shopify:block:select', event => {
    if (!window.Shopify?.designMode) return;
    if (!event.target.closest('cart-drawer')) {
      if (selected) dismiss();
      return;
    }
    selected = true;
    selectedBlock = event.detail?.blockId || event.target;
    update();
    event.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
  });
  document.addEventListener('shopify:block:deselect', event => {
    if (selectedBlock === (event.detail?.blockId || event.target)) dismiss();
  });
  document.addEventListener('shopify:section:select', event => {
    if (!window.Shopify?.designMode) return;
    if (!event.target.querySelector('cart-drawer')) {
      if (selected) dismiss();
      return;
    }
    selected = true;
    selectedBlock = null;
    update();
  });
  document.addEventListener('shopify:section:deselect', event => {
    if (!event.target.querySelector('cart-drawer')) return;
    dismiss();
  });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('cart-drawer')) document.body.classList.remove('open-cc');
  });
  update();
}
